import script from "./ButtonDisplay.vue?vue&type=script&lang=ts&setup=true"
export * from "./ButtonDisplay.vue?vue&type=script&lang=ts&setup=true"

import "./ButtonDisplay.vue?vue&type=style&index=0&id=3c36588c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c36588c"]])

export default __exports__